<mat-card class="card-style modal-card px-6 py-6 pt-0">
  <mat-card-header class="modal-header flex justify-between items-center">
    <mat-card-title>
      {{ editavel ? 'Informar valores' : 'Valores da cotação' }}
    </mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div class="mt-8">
    <!-- Mesmo cabeçalho da tela de cotação do operador, menos os campos que o backend não
         manda ao fornecedor de propósito (cliente, subcliente e consultores). -->
    <mat-card class="card-style px-4 py-6">
      <h5>Proposta</h5>
      <div class="flex justify-between items-center gap-4 mb-4">
        <div class="w-1/4"><b>tg cod:</b> {{ item.codigoTg ?? '-' }}</div>
        <div class="w-1/4"><b>Evento:</b> {{ item.nomeEvento ?? '-' }}</div>
        <div class="w-1/4"><b>Inicio:</b> {{ item.dataInicio ?? '-' }}</div>
        <div class="w-1/4"><b>Fim:</b> {{ item.dataFinal ?? '-' }}</div>
      </div>
      <div class="flex justify-between items-center gap-4 mb-4">
        <div class="w-1/4"><b>PAX:</b> {{ item.pax || '-' }}</div>
      </div>

      <mat-divider></mat-divider>

      <div class="flex justify-between items-center gap-4 mt-4">
        <h5>Trecho</h5>
        <button mat-raised-button class="btn-add" (click)="viewItinerariesItem()">
          <mat-icon>route</mat-icon>
          Itinerários
        </button>
      </div>
      <div class="flex justify-between items-center gap-4 mb-4">
        <div class="w-1/4"><b>Status:</b> {{ descricaoStatus }}</div>
        <div class="w-1/4"><b>Origem:</b> {{ item.origem ?? '-' }}</div>
        <div class="w-1/4"><b>Destino:</b> {{ item.destino ?? '-' }}</div>
        <div class="w-1/4">
          <b>Período:</b> {{ item.dataInicio ?? '-' }} - {{ item.dataFinal ?? '-' }}
        </div>
      </div>
      <div class="flex justify-between items-center gap-4 mb-4">
        <div class="w-1/4">
          <b>Tipo de serviço:</b> {{ item.descricaoTipoServico ?? '-' }}
        </div>
        <div class="w-1/4"><b>Serviço:</b> {{ item.descricaoServico ?? '-' }}</div>
        <div class="w-1/4">
          <b>Tipo veículo:</b> {{ item.descricaoTipoVeiculo ?? '-' }}
        </div>
        <div class="w-1/4">
          <b>Tipo motorista:</b> {{ item.descricaoTipoMotorista ?? '-' }}
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="flex justify-between items-center gap-4 mt-4">
        <div class="w-full">
          <b>Observação:</b><br />
          <div class="text-base font-semibold text-red-800 whitespace-pre-line">
            {{ item.observacao ?? '' }}
          </div>
        </div>
      </div>
    </mat-card>

    @if (item.statusId === statusRecusado && item.motivoRecusaDescricao) {
      <mat-card class="card-style note-card px-4 py-2 mt-4">
        <div class="w-full py-2">
          <b>Motivo da recusa:</b> {{ item.motivoRecusaDescricao }}
          @if (item.obsRecusa) {
            <br />{{ item.obsRecusa }}
          }
        </div>
      </mat-card>
    }

    <div [formGroup]="form">
      <div class="flex flex-wrap justify-start gap-4 items-center mt-6">
        <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
          <mat-label>Valor custo</mat-label>
          @if (form.get('cost')!.value != '') {
            <span matTextPrefix>R$&nbsp;</span>
          }
          <input matInput formControlName="cost" currencyInput />
        </mat-form-field>

        <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
          <mat-label>Custo hora extra</mat-label>
          @if (form.get('costOvertime')!.value != '') {
            <span matTextPrefix>R$&nbsp;</span>
          }
          <input matInput formControlName="costOvertime" currencyInput />
        </mat-form-field>

        <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
          <mat-label>Custo Km extra</mat-label>
          @if (form.get('costKmExtra')!.value != '') {
            <span matTextPrefix>R$&nbsp;</span>
          }
          <input matInput formControlName="costKmExtra" currencyInput />
        </mat-form-field>
      </div>

      @if (editavel) {
        <mat-form-field class="input-tg w-full" appearance="outline">
          <mat-label>Observações</mat-label>
          <textarea
            matInput
            formControlName="observacao"
            rows="3"
            maxlength="500"
            placeholder="Opcional — ex.: valor com pedágio incluso"
          ></textarea>
          <mat-hint align="end">{{ form.get('observacao')?.value?.length ?? 0 }}/500</mat-hint>
        </mat-form-field>
      }

      <div class="flex justify-end gap-4 items-center mt-6">
        @if (editavel) {
          <button
            mat-flat-button
            class="btn-tg w-3/12"
            [disabled]="form.invalid || loading"
            (click)="confirmarEnvio()"
          >
            @if (loading) {
              <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
            } @else {
              Enviar valores
            }
          </button>
        } @else {
          <button mat-flat-button class="btn-tg-white w-3/12" (click)="close()">
            Fechar
          </button>
        }
      </div>
    </div>
  </div>
</mat-card>
